import { render, staticRenderFns } from "./WorldViewEditPage.vue?vue&type=template&id=235b969d&scoped=true"
import script from "./WorldViewEditPage.vue?vue&type=script&lang=ts"
export * from "./WorldViewEditPage.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewEditPage.vue?vue&type=style&index=0&id=235b969d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b969d",
  null
  
)

export default component.exports